import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Componente que protege rotas administrativas
 * Verifica se o usuário logado possui a flag admin=true no banco
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, signed } = useAuth();

  // Se não está autenticado, redireciona para login
  if (!signed) {
    return <Navigate to="/tw/login" replace />;
  }

  // Verifica se o usuário tem a flag admin no banco de dados
  const isAdmin = user?.admin === true;

  if (!isAdmin) {
    // Se não é admin, redireciona para o dashboard
    return <Navigate to="/tw/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
